export const environment = {
  production: false,
  apiUrl: 'https://uat.truth-api.cmgservicing.com',
  msalConfig: {
    auth: {
      clientId: 'a5c85c2a-31ce-4252-9649-8b3cf1f74ff4',
      authority: 'https://login.microsoftonline.com/57d88166-f247-4dee-a6f9-e6359f96ff2c',
    },
    apiScope: 'api://baf6f1f5-ec26-4d73-8d55-e5c7727c84f2/adminapiscope',
    graphScope: 'user.read',
    graphUri: 'https://graph.microsoft.com/v1.0/',
  },
};
